import { render, staticRenderFns } from "./FormFieldSetCreateFields.vue?vue&type=template&id=571c8f09&scoped=true&"
import script from "./FormFieldSetCreateFields.vue?vue&type=script&lang=ts&"
export * from "./FormFieldSetCreateFields.vue?vue&type=script&lang=ts&"
import style0 from "./FormFieldSetCreateFields.vue?vue&type=style&index=0&id=571c8f09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571c8f09",
  null
  
)

export default component.exports